import type { ListBuilderList } from '../../../types';
import { createTransactionColumns } from '../columns';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * All transactions list - base list showing all transactions
 */
export const allTransactionsList: ListBuilderList = {
	id: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'All Transactions',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createTransactionColumns(),
	description:
		'Complete list of all transaction summaries with payment details',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: BASE_FILTER_RULES,
};
